export const TEST_ID = 'checkmarkIcon';
